<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Pracownicy</v-flex>

        <v-spacer />

        <v-flex>
          <search />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <router-link v-if="isOfficial" :to="{ name: 'partner', params: { id: partnerId } }">
            <v-btn small color="primary"> <v-icon>mdi-undo</v-icon>Profil Partnera </v-btn>
          </router-link>
        </v-flex>

        <v-flex text-xs-right>
          <check-permission permissions="PARTNER.EMPLOYEE_ADD" entityType="partner" :entityId="partnerId">
            <v-btn large color="error" @click="showAddModal">DODAJ PRACOWNIKA</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        entityType="profile"
        :headers="table.headers"
        :actions="actions"
        :items="list"
        :total-count="count"
        @add="showAddModal"
        @edit="showEditModal($event.userId)"
        @delete="showDeleteDialog($event.id)"
        @details="goToDetails"
        @roles="goToRoles"
      />

      <material-dialog
        title="Potwierdź usunięcie"
        :show="!!idToDelete"
        :id="idToDelete"
        :text="confirmDeleteText"
        @close="hideDeleteDialog"
        @confirm="remove"
      />
    </material-card>

    <modal :show="showModal" :id="idToEdit" :edit="!!idToEdit" @close="hideModal" @save="add" @update="update" />
  </v-container>
</template>

<script>
import { isOfficial, SessionStorage } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Search from '@/components/material/table/Search';
import { listMixin } from '@/mixins/list';
import store from '@/store/store';
import { DELETE_ACTION, DETAILS_ACTION, EDIT_ACTION, ROLES_ACTION } from '@/utils/actions';
import Modal from './modals/Employee.modal';

// @vuese
// Wyświetlanie listy pracowników danego partnera
// @group Partner
export default {
  mixins: [
    listMixin('employees', {
      listError: 'Wystąpił błąd podczas pobierania listy pracowników.',
      getError: 'Wystąpił błąd podczas pobierania danych pracownika.',
      added: 'Dodano pracownika.',
      addError: 'Nie udało się dodać pracownika.',
      updated: 'Zaktualizowano dane pracownika.',
      updateError: 'Nie udało się zaktualizować danych pracownika.',
      deleted: 'Usunięto pracownika.',
      deleteError: 'Nie udało się usunąć pracownika.'
    })
  ],
  components: {
    MaterialCard,
    MaterialDialog,
    MaterialTable,
    Modal,
    Search
  },
  data() {
    return {
      table: {
        headers: [
          { value: 'email', text: 'Adres e-mail', sortable: false, link: true },
          { value: 'firstName', text: 'Imię', sortable: false },
          { value: 'lastName', text: 'Nazwisko', sortable: false }
        ]
      },
      actions: [DELETE_ACTION, EDIT_ACTION, ROLES_ACTION, DETAILS_ACTION]
    };
  },
  computed: {
    ...mapState({ partnerId: state => state.partners.id }),
    toDelete() {
      if (this.idToDelete) {
        return this.list.find(item => item.id === this.idToDelete);
      }
    },
    confirmDeleteText() {
      if (this.toDelete) {
        return `Czy na pewno chcesz usunąć konto pracownika ${this.toDelete.firstName} ${this.toDelete.lastName}?`;
      }
      return '';
    },
    isOfficial
  },
  methods: {
    // @vuese
    // Przejście do szczegółów użytkownika
    goToDetails(profile) {
      if (isOfficial()) {
        this.$router.push({ name: 'employeeProfile', params: { employeeId: profile.userId } });
      } else {
        this.$router.push({ name: 'employeePartner', params: { employeeId: profile.userId } });
      }
    },
    // @vuese
    // Przejście do ról użytkownika
    goToRoles(profile) {
      if (isOfficial()) {
        this.$router.push({ name: 'employeeOfficialRoles', params: { employeeId: profile.userId } });
      } else {
        this.$router.push({ name: 'employeePartnerRoles', params: { id: profile.userId } });
      }
    }
  }
};
</script>
